export const ACTION = {
    STEAMER_TICKET: '272',//船票
    TRANSFER_ACCOUNT: '256',//转账
    RED_ENVELOPE: '144', // 红包
    ALBUM: '320', // 相册
    ARTICLE: '304', // 文章
    AUDIO: '336', // 音频
    VIDEO: '352', // 视频
}
/**
 * 1: 仅仅是一个带链接的文本消息
 * 2: iOS支持的视频通话版本，后续已经不兼容
 * 3: Android/iOS/Web互通的视频通话版本
 */
export const VERSION = 3